import ContentItem from './ContentItem';

export default ContentItem;
